<template>
  <div class="top-wrap">
      <div class="top">
          <div class="top-logo"></div>
          <div class="top-login">
              <div class="top-login-top">
                  <div class="top-login-top1" >国资处首页</div>
                  <div class="top-login-top2"></div>
                  <div class="top-login-top3" v-on:click="loginout">注销</div>
              </div>
              <div class="top-search">搜索</div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  components:{
  },
  methods:{
      loginout(){
          this.$router.push({path:'/login'})
      }
  }
}
</script>

<style lang="less" scoped>
.top-wrap{
    width: 100%;
    height: 119px;
    background: #fff;
    .top{
        width: 1200px;
        margin: 0 auto;
    }
    .top-logo{
        float: left;
        width: 627px;
        height: 65px;
        margin-top: 28px;
        background: url('../../../static/statistics/logo@2x.webp');
        background-size: 627px 65px;
    }
    .top-login{
        float: right;
        width: 304px;
        margin-top: 19px;
        .top-login-top{
            width: 155px;
            overflow: hidden;
            margin-bottom: 14px;
            margin-left: 131px;
        }
        .top-login-top1{
            cursor: pointer;
            float: left;
            height: 22px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 16px;
            color: #0F0F0F;
            letter-spacing: 0;
            line-height: 22px;
        }
        .top-login-top2{
            float: left;
            width: 1px;
            height: 20px;
            background: #E5E5E5;
            margin-left: 20px;
            margin-right: 20px;
        }
        .top-login-top3{
            float: left;
            height: 22px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 16px;
            color: #0F0F0F;
            letter-spacing: 0;
            line-height: 22px;
            cursor: pointer;
        }
        .top-search{
            width: 304px;
            height: 32px;
            border: 1px solid #D1D1D1;
            border-radius: 4px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #B8B8B8;
            letter-spacing: 0;
            line-height: 32px;
            text-indent: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/top.vue